import { commentModels } from "./comment";
import { feedbackModels } from "./feedback";
import { handbookModels } from "./handbook";
import { libraryModels } from "./library";
import { mediaModels } from "./media";
import { publicShowroomModels } from "./publicShowroom";
import { showroomModels } from "./showroom";
import { smallTeamModels } from "./smallTeam";
import { sparkModels } from "./spark";
import { userModels } from "./user";
import { workshopModels } from "./workshop";

export const MODELS = {
  ...userModels,
  ...workshopModels,
  ...sparkModels,
  ...publicShowroomModels,
  ...smallTeamModels,
  ...showroomModels,
  ...commentModels,
  ...libraryModels,
  ...mediaModels,
  ...feedbackModels,
  ...handbookModels,
};
